import { render, staticRenderFns } from "./MindMethod.vue?vue&type=template&id=6969d02c&scoped=true&lang=pug&"
import script from "./MindMethod.vue?vue&type=script&lang=js&"
export * from "./MindMethod.vue?vue&type=script&lang=js&"
import style0 from "./MindMethod.styl?vue&type=style&index=0&id=6969d02c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969d02c",
  null
  
)

export default component.exports